import { render, staticRenderFns } from "./ApprovalInfo.vue?vue&type=template&id=c03bd426&scoped=true&"
import script from "./ApprovalInfo.vue?vue&type=script&lang=js&"
export * from "./ApprovalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalInfo.vue?vue&type=style&index=0&id=c03bd426&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c03bd426",
  null
  
)

export default component.exports